module.exports = __webpack_public_path__ + "resources/img/cordova.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/cordova.png
// module id = 1100
// module chunks = 0